import React, { useEffect, useState } from "react";
import { Menu, X, Phone, Mail, MapPin, Clock } from "lucide-react";
import { company, navLinks } from "../mock";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("#home");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      const sections = navLinks.map((l) => l.href.replace("#", ""));
      for (const id of sections) {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 140 && rect.bottom >= 140) {
            setActive("#" + id);
            break;
          }
        }
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    const el = document.getElementById(href.replace("#", ""));
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 78;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
    setOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 w-full z-50">
      {/* Top info bar */}
      <div className="hidden lg:block" style={{ background: "var(--navy-deep)" }}>
        <div className="max-w-7xl mx-auto px-6 flex justify-between items-center text-white/85 text-[13px] py-2">
          <div className="flex items-center gap-7">
            <span className="flex items-center gap-2">
              <MapPin size={15} className="text-[#e07c24]" /> {company.address}
            </span>
            <span className="flex items-center gap-2">
              <Clock size={15} className="text-[#e07c24]" /> {company.hours}
            </span>
          </div>
          <div className="flex items-center gap-7">
            <a href={`mailto:${company.email}`} className="flex items-center gap-2 hover:text-white transition-colors">
              <Mail size={15} className="text-[#e07c24]" /> {company.email}
            </a>
            <a href={`tel:${company.phoneLink}`} className="flex items-center gap-2 hover:text-white transition-colors">
              <Phone size={15} className="text-[#e07c24]" /> {company.phone}
            </a>
          </div>
        </div>
      </div>

      {/* Main nav */}
      <div
        className="transition-all duration-300"
        style={{
          background: "#ffffff",
          boxShadow: scrolled ? "0 8px 30px -12px rgba(10,31,77,0.28)" : "0 2px 10px -6px rgba(10,31,77,0.15)",
        }}
      >
        <div className="max-w-7xl mx-auto px-5 md:px-6 flex items-center justify-between h-[68px]">
          <a href="#home" onClick={(e) => go(e, "#home")} className="flex items-center">
            <img src={company.logo} alt={company.legal} className="h-[46px] md:h-[52px] w-auto" />
          </a>

          <nav className="hidden lg:flex items-center gap-9">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => go(e, l.href)}
                className={`nav-link text-[15px] font-semibold tracking-wide ${
                  active === l.href ? "active text-[#14357e]" : "text-slate-700"
                }`}
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#contact"
              onClick={(e) => go(e, "#contact")}
              className="btn-orange hidden sm:inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-sm"
            >
              <Phone size={16} /> Free Consultation
            </a>
            <button
              className="lg:hidden text-[#14357e]"
              onClick={() => setOpen((o) => !o)}
              aria-label="Menu"
            >
              {open ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        <div
          className="lg:hidden overflow-hidden transition-all duration-300 bg-white border-t border-slate-100"
          style={{ maxHeight: open ? "340px" : "0px" }}
        >
          <nav className="flex flex-col px-6 py-3">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => go(e, l.href)}
                className="py-3 border-b border-slate-100 font-semibold text-slate-700"
              >
                {l.label}
              </a>
            ))}
            <a
              href={`tel:${company.phoneLink}`}
              className="mt-3 mb-2 btn-orange text-center px-6 py-3 rounded-full font-semibold"
            >
              Call {company.phone}
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
